import { APP_NAME } from '@/config'
import { ZAP_PATH, ZAP_WIDTH } from './wordmarkZap'
import './Wordmark.css'

type Props = { className?: string }

/*
 * The logo: "Cupl" set solid in Sora Bold, then "zap" outlined, with the z drawn as a lightning
 * bolt. "zap" is a pre-drawn path from Sora's own letters with the outlines and spacing baked
 * in, so it needs no font and no background colour. The colours of the two halves come from
 * --logo-solid and --logo-outline in tokens.css.
 */
export function Wordmark({ className }: Props) {
  const at = APP_NAME.length - 3
  const classes = className ? `wordmark ${className}` : 'wordmark'
  if (APP_NAME.slice(at).toLowerCase() !== 'zap') return <span className={classes}>{APP_NAME}</span>
  return (
    <span className={classes} role="img" aria-label={APP_NAME}>
      <span className="wordmark__solid" aria-hidden="true">
        {APP_NAME.slice(0, at)}
      </span>
      {/* "slice" lets the whole-pixel 1em height set the scale, whatever the width rounds to. */}
      <svg className="wordmark__zap" viewBox={`0 -200 ${ZAP_WIDTH} 200`} preserveAspectRatio="xMinYMax slice" aria-hidden="true">
        <path d={ZAP_PATH} fill="currentColor" />
      </svg>
    </span>
  )
}
